import { FlossPalette } from '@orthly/ui-primitives';

export const PRINTABLE_SLIP_DARK_COLOR = FlossPalette.BLACK;

export const PRINTABLE_SLIP_FADED_TEXT_COLOR = '#a8a7a1';

export const PRINTABLE_SLIP_NESTED_BORDER_COLOR = '#d9d9d9';
